import { WEB_TOOL } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import LinkEditPreviewDrawer from '../link/link-edit-preview-drawer';
import { EditProps } from '../link/link.constants';

const WebToolSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <LinkEditPreviewDrawer {...props} />
  ) : (
    <StimulusLibrary
      stimulusType={WEB_TOOL}
      title="Web Tool"
      componentId={props.id}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={WEB_TOOL}
        />
      }
      {...props}
    />
  );
};

export default WebToolSettings;
